<template>
    <div>
        <div class="header-btn">
            <el-button type="primary" icon="el-icon-plus" size="medium" @click="addProperty">Add Property</el-button>
        </div>
        <el-table
                :data="data"
                style="width: 100%">
            <el-table-column
                    v-for="item in [
      {prop:'propertyName',label:'Property Name'},
      {prop:'companyName',label:'Company Name'},
      {prop:'updatedDate',label:'Data Updated'},
      ]"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>
            <el-table-column label="Action">
                <tempate slot-scope="s">
                    <el-button type="warning" size="medium" icon="el-icon-edit">Edit</el-button>
                    <el-button type="primary" size="medium" icon="el-icon-plus">Facility Config</el-button>
                    <el-button type="primary" size="medium" icon="el-icon-plus">Unit</el-button>
                </tempate>
            </el-table-column>
        </el-table>
        <div class="page">
            <el-pagination v-if="page.total>1"
                           @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>
        <el-dialog
                v-if="dialogVisible"
                center
                :visible.sync="dialogVisible"
                width="60%">
            <el-form ref="form" :model="property" label-position="left">
                <el-row style="margin-top: 1rem">
                    <el-form-item label="Property Name" label-width="10%">
                        <el-col :span="8">
                            <el-input v-model="property.propertyName"></el-input>
                        </el-col>
                    </el-form-item>
                </el-row>
                <el-form-item label="Property Name" label-width="10%">
                    <el-col :span="8">
                        <el-input v-model="property.prefix"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="Developer Name" label-width="15%">
                    <el-col :span="8" :offset="2">
                        <el-input v-model="property.developerName"></el-input>
                    </el-col>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'CommunityManagement',
        data() {
            return {
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                data: [{propertyName: '1'}],
                dialogVisible: false,
                property: {}
            }
        },
        methods: {
            addProperty(data) {
                this.dialogVisible = true
            }
        }
    }
</script>

<style scoped>

</style>
